export const handlePending = (state, key) => {
  state[key].loading = true;
};

export const handleRejected = (state, key) => {
  state[key].loading = false;
};

export const handleFulfilled = (state, key, action) => {
  state[key].value = action.payload;
  state[key].loading = false;
};
